import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../store/auth-context";
import '../styles/navbar.css';

const Navbar = () => {
    const [prPlusActive, setPRPlusActive] = useState(false);
    const [fanCastActive, setFanCastActive] = useState(false);

    const authCtx = useContext(AuthContext);
    const isLoggedIn = authCtx.isLoggedIn;

    const logoutHandler = () => {
        authCtx.logout();
    }

    const setDataTableRouteActive = () => {
        if (!prPlusActive) {
            setPRPlusActive(true);
            setFanCastActive(false)
        }
    };
    let dataTableRouteActiveStyle = prPlusActive ? "nav-link text-danger ms-3 me-3 active-item" : "nav-link text-dark ms-3 me-3";

    const setHomeRouteActive = () => {
        if (!fanCastActive) {
            setFanCastActive(isActive2 => !isActive2);
            setPRPlusActive(false)
        }
    };
    let homeRouteActiveStyle = fanCastActive ? "nav-link text-danger ms-3 me-3 active-item" : "nav-link text-dark ms-3 me-3";

    useEffect(() => {
        switch (window.location.pathname) {
            case '/datatable':
                setDataTableRouteActive();
                break;
            case '/home':
                setHomeRouteActive();
                break;
        }
    }, [window.location.pathname])

    return (
        <nav className="navbar navbar-expand-lg bg-light">
            <div className="container-fluid">
                <img
                    src="https://www.nicepng.com/png/full/840-8400920_pocket-radar.png"
                    alt="" height="30"/>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
                        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
                    <ul className="navbar-nav text-light">
                        {isLoggedIn &&
                            <li className="nav-item fs-5">
                                <Link to="/home" onClick={setHomeRouteActive} className={homeRouteActiveStyle}>Home</Link>
                            </li>}
                        {isLoggedIn &&
                            <li className="nav-item fs-5">
                                <Link style={{color: 'red'}} to="/datatable" onClick={setDataTableRouteActive} className={dataTableRouteActiveStyle}>Data Table</Link>
                            </li>}
                        {isLoggedIn &&
                            <li className="nav-item fs-5 pe-5">
                                <Link onClick={logoutHandler} to="/"
                                      className="nav-link text-dark ps-5">Logout</Link>
                            </li>}
                    </ul>
                    <div className="text-end">
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default Navbar;